import React from 'react';
import InputField from 'Components/InputField/InputField';

const PhoneField = () => {
  return (
    <InputField placeholder='Phone Number' />
  )
}

export default PhoneField;